import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { getRouteFromPathName } from '../../../../../shared/utils/localStorage';
import { storageKeys } from '../../../../../stores/DebuggerStore';
import { ResizeContainer } from '../Styles';

export const FullScreenButton = observer(() => {
  const {
    DebuggerStore: {
      getDebugArrayValue,
      removeDebugArrayItem,
      setDebugArrayItem,
      setUpdated,
      shouldShowLogViewerInFullscreen,
    },
  } = useStores();

  const toggle = () => {
    const key = storageKeys.showViewerInFullscreen;
    const slug = getRouteFromPathName()?.toLowerCase();
    const exists = getDebugArrayValue(key).includes(slug);
    exists ? removeDebugArrayItem(key, slug) : setDebugArrayItem(key, slug);
    setUpdated();
  };

  return (
    <ResizeContainer
      fullscreen={shouldShowLogViewerInFullscreen}
      onClick={toggle}
    >
      <i
        aria-hidden="true"
        className={`fa ${
          shouldShowLogViewerInFullscreen ? 'fa-compress' : 'fa-arrows-alt'
        }`}
      />
    </ResizeContainer>
  );
});

export default FullScreenButton;
